import farmerReducer from "./farmerReducer";
import maintainFarmerReducer from "./maintainFarmerReducer";

const farmerReducers = {
    farmer: farmerReducer,
    maintainFarmer: maintainFarmerReducer,
};

export default farmerReducers;